import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';

import Button from '@/components/Button';
import CloseIcon from '@/ui-assets/icons/close-icon.svg?react';
import { trackEvent } from '@/utils/analytics';

import modalStyles from '../../scss/modal.module.scss';
import IconButton from '../Button/IconButton';

import styles from './MobileModal.module.scss';
import type { ModalProps } from './type';

const MobileModal = ({
  className,
  isOpen = false,
  isConfirmLoading = false,
  isCancelLoading = false,
  children,
  cancelText = 'action.cancel',
  confirmText = 'action.confirm',
  cancelTextI18nProps,
  confirmTextI18nProps,
  onConfirm,
  onClose,
}: ModalProps) => {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    trackEvent(
      'confirm_modal',
      'closed',
      { eventId: 'confirm_modal_closed' },
      { modalType: 'mobile' }
    );
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    trackEvent(
      'confirm_modal',
      'clicked',
      { eventId: 'confirm_modal_confirm_button_clicked' },
      { modalType: 'mobile' }
    );
    onConfirm?.();
  }, [onConfirm]);

  return (
    <ReactModal
      shouldCloseOnEsc
      role="dialog"
      isOpen={isOpen}
      className={classNames(styles.modal, className)}
      overlayClassName={classNames(modalStyles.overlay, styles.overlay)}
      onRequestClose={handleClose}
    >
      <div className={styles.container}>
        <div style={{display: 'none'}} className={styles.header}>
          {t('description.reminder')}
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={styles.content}>{children}</div>
        <div className={styles.footer}>
          <Button
            title={cancelText}
            i18nProps={cancelTextI18nProps}
            isLoading={isCancelLoading}
            type="secondary"
            onClick={handleClose}
          />
          {onConfirm && (
            <Button
              title={confirmText}
              i18nProps={confirmTextI18nProps}
              isLoading={isConfirmLoading}
              onClick={handleConfirm}
            />
          )}
        </div>
      </div>
    </ReactModal>
  );
};

export default MobileModal;
